<style lang="less">
    .ivu-btn-primary {
        span {
            color: #fff;
        }
    }
    .ivu-modal-confirm-head-icon-confirm {
        i {
            color: #f90;
        }
    }
    .save-as-dialog {
        .save-as-content {
            display: flex;
            justify-content: space-between;

            .save-as-left {
                width: 156px;
                padding: 0px 24px 24px 0px;
                div {
                    height: 80px;
                    width: 126px;
                    margin-bottom: 4px;
                    border-radius: 6px;
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .item-icon {
                        width: 20px;
                        height: 20px;
                        fill: #424242;
                        margin-bottom: 8px;
                    }
                    &:hover:not(.active-item) {
                        background-color: rgba(0, 0, 0, 0.04);
                        color: var(--themeColor);
                    }
                    &:hover:not(.active-item) .item-icon {
                        fill: var(--themeColor);
                    }
                }
                .active-item {
                    background-color: rgba(0, 0, 0, 0.06);
                    color: var(--themeColor);
                    .item-icon {
                        fill: var(--themeColor);
                    }
                }
            }
            .save-as-right {
                position: relative;
                flex: 1;
                .table-wrap {
                    width: 512px;
                    height: 304px;
                    position: relative;
                    border: 1px solid rgba(0, 0, 0, 0.06);
                    border-radius: 6px;
                }
                .list-scroll-wrap {
                    padding: 6px;
                    height: 260px;
                    overflow: auto;
                    width: 100%;
                }
                .title-item {
                    transition: all 0.2s ease-in-out;
                    height: 40px;
                    width: 100%;
                    box-sizing: border-box;
                    cursor: pointer;
                    user-select: none;
                    position: relative;
                    display: flex;
                    -webkit-box-align: center;
                    align-items: center;
                    font-size: 12px;
                }
                .save-as-title {
                    margin-bottom: 20px;
                    color: #000;
                    font-size: 12px;
                    cursor: pointer;
                    display: flex;
                    flex-wrap: wrap;
                    padding-right: 120px;
                    .right-arrow {
                        width: 10px;
                        height: 10px;
                        position: relative;
                        top: 2px;
                    }
                    div {
                        margin-right: 4px;
                        white-space: nowrap;
                        max-width: 7rem;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    .selected-path {
                        font-weight: bold;
                    }
                }
                .save-as-newFolder {
                    position: absolute;
                    right: 10px;
                    top: 20px;
                    padding: 0 15px;
                    height: 28px;
                    line-height: 28px;
                    background: var(--themeColor);
                    border-radius: 3px;
                    user-select: none;
                    cursor: pointer;
                    transition: background 0.2s linear;
                    span {
                        color: #fff;
                        font-size: 12px;
                    }
                    &:hover {
                        background: var(--themeHover);
                    }
                }
                .files-folders-list {
                    margin-top: 0px;
                    .folder-item {
                        border-radius: 6px;
                        transition: all 0.2s ease-in-out;
                        height: 40px;
                        width: 100%;
                        box-sizing: border-box;
                        cursor: pointer;
                        user-select: none;
                        position: relative;
                        display: flex;
                        -webkit-box-align: center;
                        align-items: center;
                        font-size: 12px;
                        img {
                            margin: 0 10px;
                        }
                        .folder-text {
                            height: 100%;
                            background: transparent;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            padding: 0 5px;
                            box-sizing: border-box;
                            border: none;
                            outline: none;
                            cursor: pointer;
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            align-items: center;
                            width: 100%;
                            user-select: none;
                        }
                        span {
                            height: 100%;
                            background: transparent;
                            color: #000;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            padding: 0 5px;
                            box-sizing: border-box;
                            border: none;
                            outline: none;
                            cursor: pointer;
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            align-items: center;
                            width: 100%;
                            user-select: none;
                            margin-left: 8px;
                            flex: 1;
                            padding-right: 20px;
                        }
                        .file-time {
                            white-space: nowrap;
                            font-size: 12px;
                            min-width: 174px;
                        }
                        .file-size {
                            white-space: nowrap;
                            font-size: 12px;
                            min-width: 80px;
                        }
                        .folder-rename {
                            height: 100%;
                            background: transparent;
                            color: #000;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            padding: 0 5px;
                            box-sizing: border-box;
                            border: none;
                            outline: none;
                            display: flex;
                            align-items: center;
                            width: 100%;
                        }
                        &:hover {
                            background: rgba(0, 0, 0, 0.04);
                        }
                    }
                }
                .list-header {
                    padding: 0 16px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
                    .file-time {
                    }
                    span {
                        width: 191px;
                        text-align: left;
                    }
                }
                .files-box-list,
                .list-header {
                    .active-file {
                        background: rgba(0, 0, 0, 0.06);
                    }
                    .files-item,
                    .title-item {
                        border-radius: 6px;
                        width: 100%;
                        height: 40px;
                        text-align: center;
                        font-size: 13px;
                        // cursor: pointer;
                        position: relative;
                        user-select: none;
                        display: flex;
                        -webkit-box-align: center;
                        align-items: center;
                        img {
                            margin: 0 10px;
                            width: 21px;
                            height: 25px;
                            object-fit: cover;
                        }
                        .file-name {
                            height: 100%;
                            background: transparent;
                            // color: #000;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            padding: 0 5px;
                            box-sizing: border-box;
                            border: none;
                            outline: none;
                            // cursor: pointer;
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            align-items: center;
                            width: 100%;
                            user-select: none;
                            flex: 1;
                            margin-right: 20px;
                            max-width: 140px;
                            p {
                                font-size: 12px;
                                width: 100%;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                text-align: left;
                            }
                        }
                        .file-rename {
                            height: 100%;
                            background: transparent;
                            color: #000;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            padding: 0 5px;
                            box-sizing: border-box;
                            border: none;
                            outline: none;
                            display: flex;
                            align-items: center;
                            width: 100%;
                        }
                        .file-time {
                            white-space: nowrap;
                            font-size: 12px;
                            min-width: 174px;
                            text-align: left;
                        }

                        .file-size {
                            white-space: nowrap;
                            font-size: 12px;
                            max-width: 80px;
                            text-align: left;
                        }

                        &:not(.title-item):not(.active-file):hover {
                            background: rgba(0, 0, 0, 0.04);
                        }
                    }
                }
            }
        }
        .save-as-btnbox {
            margin-top: 12px;
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .save-as-btnbox-left {
                display: flex;
                justify-content: space-between;
                align-items: center;
                input {
                    margin-left: 20px;
                    border: 1px solid rgba(0, 0, 0, 0.06);
                    border-radius: 6px;
                    flex: 1;
                    height: 28px;
                    text-indent: 8px;
                    outline: none;
                    width: 183px;
                }
            }
            .save-as-btnbox-right {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }
    }
    .save-as-createFolderBox {
        input {
            text-indent: 12px;
            border-radius: 4px;
            height: 36px;
            width: 100%;
            border: 1px solid #007fff;
            outline: none;
        }
    }
    .loading-container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .loading-box {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            width: 100px;
            img {
                width: 50px;
                height: 50px;
            }
            p {
                margin-top: 10px;
                font-size: 14px;
                color: #000;
            }
        }
    }
</style>

<template>
    <Dialog class="save-as-dialog" :title="language === 'zh' ? $t('cloud') : $t('title')" :mask="true" @close="closeThis">
        <div class="save-as-content">
            <div class="save-as-left" v-if="!internal">
                <!-- <div :class="{'active-item': index == 1}" @click="selectItem(1)"><iconSymbol class="item-icon" name="save-as-1"></iconSymbol>{{$t('local')}}</div> -->
                <div :class="{ 'active-item': index == 2 }" @click="selectItem(2)">
                    <iconSymbol class="item-icon" name="save-as-2"></iconSymbol>
                    {{ $t("cloud") }}
                </div>
                <div :class="{ 'active-item': index == 3 }" @click="selectItem(3)" v-if="language === 'en' && !isTeamsApp && !isSaveSpecPage">
                    <iconSymbol class="item-icon" name="save-as-3"></iconSymbol>
                    {{ $t("google") }}
                </div>
                <div :class="{ 'active-item': index == 4 }" @click="selectItem(4)" v-if="language === 'en' && !isTeamsApp && !isSaveSpecPage">
                    <iconSymbol class="item-icon" name="save-as-4"></iconSymbol>
                    {{ $t("dropbox") }}
                </div>
            </div>
            <div class="save-as-right">
                <div class="table-wrap" v-if="index == 1">
                    <div class="save-as-title">电脑>桌面>亿图图示文件</div>
                </div>
                <div v-if="index == 2">
                    <div class="save-as-title">
                        <div :class="{ 'selected-path': path.length == 0 }" @click="setPath(null)">{{ $t("Personal") }}</div>
                        <div v-if="path.length > 2">
                            <icon-symbol class="right-arrow" name="right-arrow" />
                            ...
                        </div>
                        <div
                            v-for="(item, index) in path"
                            :key="index"
                            v-show="index === path.length - 1 || index === path.length - 2"
                            :class="{ 'selected-path': path.length == index + 1 }"
                            @click="setPath(index)"
                        >
                            <icon-symbol class="right-arrow" name="right-arrow" />
                            {{ item }}
                        </div>
                    </div>
                    <div class="table-wrap">
                        <div class="save-as-newFolder" @click="showCreateFolderBox()" v-if="false">
                            <span>{{ $t("createFolder") }}</span>
                        </div>
                        <div class="list-header">
                            <div class="title-item">
                                <span>{{ $t("name") }}</span>
                                <div class="file-time">{{ $t("time") }}</div>
                                <div class="file-size">{{ $t("size") }}</div>
                            </div>
                        </div>
                        <div class="list-scroll-wrap" v-show="!loadingPersonal">
                            <div class="files-folders-list">
                                <div class="folder-item" v-for="(item, index) in folderList" :key="index" @dblclick="openFolder(item)">
                                    <img :src="require('@/home/assets/img/files/folder-list.svg')" alt="" />
                                    <div class="folder-text" style="">{{ item.name }}</div>
                                </div>
                            </div>
                            <div class="files-box-list">
                                <div
                                    class="files-item"
                                    :class="{ 'active-file': index == fileIndex }"
                                    v-for="(item, index) in filesList"
                                    :key="index"
                                    @click="select(index, item)"
                                >
                                    <img :src="filesImg(item.info)" @error="coverError($event)" />
                                    <div class="file-name">
                                        <p>{{ item.name }}</p>
                                    </div>
                                    <div class="file-time">{{ new Date(item.lastModified).toLocaleString() }}</div>
                                    <div class="file-size">{{ (item.size / 1000).toFixed(2) }}KB</div>
                                </div>
                            </div>
                        </div>
                        <div class="loading-container" v-show="loadingPersonal">
                            <div class="loading-box">
                                <img :src="require('@/app/assets/loading.gif')" alt="" />
                                <p>{{ $t("loading") }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="index == 3">
                    <div class="save-as-title">
                        <div :class="{ 'selected-path': drivePath.length == 0 }" @click="setDrivePath(null)">Google Drive</div>
                        <div
                            v-for="(item, index) in drivePath"
                            :key="index"
                            :class="{ 'selected-path': drivePath.length == index + 1 }"
                            @click="setDrivePath(item, index)"
                        >
                            > {{ item.name }}
                        </div>
                    </div>
                    <div class="table-wrap">
                        <div class="files-folders-list">
                            <div class="folder-item">
                                <span>{{ $t("name") }}</span>
                                <div class="file-time">{{ $t("time") }}</div>
                                <div class="file-size">{{ $t("size") }}</div>
                            </div>
                            <div class="folder-item" v-for="(item, index) in driveFolderList" :key="index" @dblclick="openDriveFolder(item)">
                                <img :src="require('@/home/assets/img/files/folder-list.svg')" />
                                <div class="folder-text" style="">{{ item.name }}</div>
                            </div>
                        </div>
                        <div class="files-box-list">
                            <div class="files-item" v-for="(item, index) in driveFilesList" :key="index">
                                <img :src="require('@/home/assets/img/files/file-list.svg')" />
                                <div class="file-name">
                                    <p>{{ item.name }}</p>
                                </div>
                                <div class="file-time">{{ new Date(item.modifiedTime).toLocaleString() }}</div>
                                <div class="file-size">{{ (item.size / 1000).toFixed(2) }}KB</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="index == 4">
                    <div class="save-as-title">
                        <div :class="{ 'selected-path': dropboxPath.length == 0 }" @click="setDropboxPath(null)">EdrawMax</div>
                        <div
                            v-for="(item, index) in dropboxPath"
                            :key="index"
                            :class="{ 'selected-path': dropboxPath.length == index + 1 }"
                            @click="setDropboxPath(index)"
                        >
                            > {{ item }}
                        </div>
                    </div>
                    <div class="table-wrap">
                        <div class="files-folders-list">
                            <div class="folder-item">
                                <span>{{ $t("name") }}</span>
                                <div class="file-time">{{ $t("time") }}</div>
                                <div class="file-size">{{ $t("size") }}</div>
                            </div>
                            <div class="folder-item" v-for="(item, index) in dropboxFolderList" :key="index" @dblclick="openDropBoxFolder(item)">
                                <img :src="require('@/home/assets/img/files/folder-list.svg')" />
                                <div class="folder-text" style="">{{ item.name }}</div>
                            </div>
                        </div>
                        <div class="files-box-list">
                            <div class="files-item" v-for="(item, index) in dropboxFilesList" :key="index">
                                <img :src="require('@/home/assets/img/files/file-list.svg')" />
                                <div class="file-name">
                                    <p>{{ item.name }}</p>
                                </div>
                                <div class="file-time">{{ new Date(item.client_modified).toLocaleString() }}</div>
                                <div class="file-size">{{ (item.size / 1000).toFixed(2) }}KB</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="save-as-btnbox">
            <div class="save-as-btnbox-left">
                {{ $t("fileName") }}
                <input type="text" ref="nameInput" v-model="fileName" @keypress.enter="confirm()" />
            </div>
            <div class="save-as-btnbox-right">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="dialog-btn-cancel" @click="closeThis()">{{ $t("cancel") }}</div>
            </div>
        </div>

        <Modal
            v-model="showCreateFolder"
            class="save-as-createFolderBox"
            :title="$t('createFolder')"
            @on-ok="okCreateFolder"
            @on-cancel="cancelCreateFolder"
        >
            <input id="renameInput" :placeholder="$t('inputFolderTip')" v-model="folderName" maxlength="32" />
        </Modal>
    </Dialog>
</template>

<script lang="ts">
    declare var saveAs: any;
    import appConfig from "@/public/globalConfig";
    import { Component, Watch, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    import { Dropbox } from "dropbox";
    import googleApi from "../../utils/googleApi.js";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class SaveAs extends Vue {
        // 初始数据可以直接声明为实例的属性
        index = 2;
        folderList = [];
        filesList = [];
        loadingPersonal = true;
        path = [];
        dropboxPath = [];
        drivePath = [];
        fileName = this.isSaveSpecPage ? window["_view"]._activePage._name : window["_view"]._doc._fileName;
        dbx = null;
        dropboxFolderList = [];
        dropboxFilesList = [];
        driveFolderList = [];
        driveFilesList = [];
        google: any;
        googleFiles = [];
        fileIndex = null;
        language = appConfig.language;
        showCreateFolder = false;
        folderName = "";
        lockCreate = false;
        folderId = 0;

        filesImg(hasInfo) {
            if (hasInfo) {
                let img = hasInfo.img;
                let exp = hasInfo.down_exp;
                let sign = hasInfo.img_sign || hasInfo.img_down_sign;
                let key = !!hasInfo.img_sign ? this.OSSAccessKeyId : "V4UkdUUAM3K63bGL";
                return this.internal
                    ? `${window["GLOBAL"].PRIVATE_OSS_HOST}${img}?OSSAccessKeyId=${key}&Expires=${exp}&Signature=${encodeURIComponent(sign)}`
                    : `${window["GLOBAL"].PRIVATE_OSS_HOST}${img}?${sign}`;
            } else {
                return require("@/home/assets/img/files/file-list.svg");
            }
        }
        coverError(e) {
            e.target.src = require("@/home/assets/img/files/file-list.svg");
        }

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        get isSaveSpecPage() {
            return this.$store.state.page.isSaveSpecPage;
        }

        selectItem(index) {
            this.index = index;
            if (index == 2) {
                this.path = [];
                if (!this.userInfo) {
                    let ts: any = this;
                    ts.$bus.$emit("login");
                } else {
                    this.getFloder("");
                }
            } else if (index == 4) {
                let dropboxToken = localStorage.getItem("dropbox_access_token");
                if (!dropboxToken) {
                    this.dbx = new Dropbox({
                        clientId: "5bt9id87y41ps12",
                    });
                    let org = window.location.origin + appConfig["sourcePath"] + "dropboxcallback";

                    let authurl = this.dbx.getAuthenticationUrl(org);
                    window.open(authurl);
                } else {
                    this.dbx = new Dropbox({
                        accessToken: dropboxToken,
                    });
                    this.dropboxPath = [];
                    this.getDropBoxFloder("");
                }
            } else if (index == 3) {
                this.google = googleApi();
                this.google.loadClient().then((res) => {
                    this.google.initClient().then((res) => {
                        let isSignedIn = this.google.AuthManager.isSignedIn();
                        console.log(res, isSignedIn);
                        if (!isSignedIn) {
                            this.google.AuthManager.signIn();
                        } else {
                            this.getGoogleFile();
                        }
                    });
                });
            }
        }

        closeThis() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            // 保存左下角指定单页重置为false
            setTimeout(() => {
                this.$store.commit("setPageStat", {
                    type: "isSaveSpecPage",
                    data: false,
                });
            }, 1000);
        }

        select(index, item) {
            this.fileIndex = index;
            this.fileName = item.name;
        }

        setPath(index) {
            if (index === null) {
                this.getFloder("");
                this.path = [];
            } else {
                let len = this.path.length - 1 - index;
                for (let i = 0; i < len; i++) {
                    this.path.pop();
                }
                let prefix = this.path.join("/") + "/";
                this.getFloder(prefix);
            }
        }

        setDropboxPath(index) {
            if (index === null) {
                this.getDropBoxFloder("");
                this.dropboxPath = [];
            } else {
                let len = this.dropboxPath.length - 1 - index;
                for (let i = 0; i < len; i++) {
                    this.dropboxPath.pop();
                }
                let prefix = "/" + this.dropboxPath.join("/") + "/";
                this.getDropBoxFloder(prefix);
            }
        }

        setDrivePath(item, index) {
            if (item === null) {
                this.getGoogleFile();
                this.drivePath = [];
            } else {
                let len = this.drivePath.length - 1 - index;
                for (let i = 0; i < len; i++) {
                    this.drivePath.pop();
                }
                let fileList = [];
                let folderList = [];
                this.googleFiles.forEach((file) => {
                    if (!file.mimeType.endsWith(".folder") && file.parents && file.parents[0] == item.id) {
                        fileList.push(file);
                    }
                    if (file.mimeType.endsWith(".folder") && file.parents && file.parents[0] == item.id) {
                        folderList.push(file);
                    }
                });
                this.driveFolderList = folderList;
                this.driveFilesList = fileList;
            }
        }

        openFolder(item) {
            this.path.push(item.name);
            let prefix = this.path.join("/") + "/";
            this.getFloder(prefix);
            if (this.isPrivate) {
                this.folderId = item.folder_id;
            }
        }

        openDropBoxFolder(item) {
            this.dropboxPath.push(item.name);
            let prefix = "/" + this.dropboxPath.join("/") + "/";
            this.getDropBoxFloder(prefix);
        }

        openDriveFolder(item) {
            this.drivePath.push(item);
            let fileList = [];
            let folderList = [];
            this.googleFiles.forEach((file) => {
                if (!file.mimeType.endsWith(".folder") && file.parents && file.parents[0] == item.id) {
                    fileList.push(file);
                }
                if (file.mimeType.endsWith(".folder") && file.parents && file.parents[0] == item.id) {
                    folderList.push(file);
                }
            });
            this.driveFolderList = folderList;
            this.driveFilesList = fileList;
        }

        getGoogleFile() {
            this.google.FileManager.listFiles({
                q: "",
                success: (res) => {
                    console.log(res);
                    let fileList = [];
                    let folderList = [];
                    this.googleFiles = res.result.files;
                    let parent = null;
                    if (this.drivePath.length > 0) {
                        parent = this.drivePath[this.drivePath.length - 1];
                    }
                    if (parent) {
                        res.result.files.forEach((file) => {
                            if (!file.mimeType.endsWith(".folder") && file.name.endsWith(".eddx") && file.parents && file.parents[0] == parent.id) {
                                fileList.push(file);
                            }
                            if (file.mimeType.endsWith(".folder") && file.parents && file.parents[0] == parent.id) {
                                folderList.push(file);
                            }
                        });
                    } else {
                        res.result.files.forEach((file) => {
                            if (!file.mimeType.endsWith(".folder") && file.name.endsWith(".eddx")) {
                                fileList.push(file);
                            }
                            if (file.mimeType.endsWith(".folder")) {
                                folderList.push(file);
                            }
                        });
                    }
                    this.driveFolderList = folderList;
                    this.driveFilesList = fileList;
                },
                error: (err) => {
                    console.log(err);
                },
            });
        }

        getDropBoxFloder(prefix) {
            this.dbx.filesListFolder({ path: prefix, recursive: true }).then((res) => {
                let folders = res.entries.filter((item) => {
                    return (
                        item[".tag"] == "folder" &&
                        item["name"] != this.dropboxPath[this.dropboxPath.length - 1] &&
                        item["path_display"].split("/").length == this.dropboxPath.length + 2
                    );
                });
                let files = res.entries.filter((item) => {
                    return item[".tag"] == "file" && item["name"].endsWith(".eddx");
                });
                this.dropboxFolderList = folders;
                this.dropboxFilesList = files;
            });
        }

        getFloder(prefix) {
            this.folderList = [];
            this.filesList = [];
            this.loadingPersonal = true;
            this.$store
                .dispatch("getFloder", { prefix })
                .then((res) => {
                    let folderList = res.data.data.folders || [];
                    let filesList = res.data.data.files || [];
                    folderList.map((item) => {
                        let list = item.prefix.split("/");
                        item.name = list[list.length - 2];
                    });
                    if (this.isPrivate) {
                        filesList.map((item) => {
                            item.name = item.info.name;
                        });
                    } else {
                        filesList.map((item) => {
                            let list = item.key.split("/");
                            let name = list[list.length - 1];
                            name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                            item.name = name;
                        });
                        filesList = filesList.filter((item) => {
                            if (item.key.match(/.+eddx$/)) {
                                return true;
                            }
                            return false;
                        });
                    }
                    this.folderList = folderList;
                    this.filesList = filesList.sort((a, b) => {
                        return new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime();
                    });
                })
                .finally(() => {
                    this.loadingPersonal = false;
                });
        }

        confirm() {
            this.fileName = this.fileName.trim();
            if (!this.fileName) {
                (<any>this).$Modal.confirm({
                    title: this.$t("tip"),
                    content: this.$t("noEmpty"),
                    okText: this.$t("confirm"),
                    cancelText: this.$t("cancel"),
                    onOk: () => {},
                    onCancel: () => {},
                });
                return;
            }
            if (this.fileName.match(/[\/\\]/)) {
                this.$edMessage.warning(this.$t("renameFail"));
                (<any>this.$refs.nameInput).focus();
                return;
            }
            if (this.index == 1) {
                window["_view"]
                    .zipFile()
                    .then((content) => {
                        let docName = this.fileName.endsWith(".eddx") ? this.fileName : this.fileName + ".eddx";
                        saveAs(content[0], docName);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else if (this.index == 2) {
                console.log(1234);
                let isSameName = false;
                this.filesList.forEach((file) => {
                    if (file.name == this.fileName) {
                        isSameName = true;
                    }
                });
                if (isSameName) {
                    (<any>this).$Modal.confirm({
                        title: this.$t("cover"),
                        content: this.$t("isCover"),
                        okText: this.$t("confirm"),
                        cancelText: this.$t("cancel"),
                        onOk: () => {
                            this.saveToOss(true);
                        },
                        onCancel: () => {},
                    });
                    return;
                }
                this.saveToOss(false);
            } else if (this.index == 4) {
                window["_view"].zipFile().then((content) => {
                    let name = this.fileName;
                    if (!name.endsWith(".eddx")) {
                        name += ".eddx";
                    }
                    this.dbx
                        .filesUpload({
                            contents: content[0],
                            path: this.dropboxPath.length > 0 ? "/" + this.dropboxPath.join("/") + "/" + name : "/" + name,
                            mode: "overwrite",
                        })
                        .then((res) => {
                            let prefix = "/" + this.dropboxPath.join("/") + "/";
                            this.getDropBoxFloder(prefix);
                            this.$edMessage.success(this.$t("saveSuccess"));
                            this.closeThis();
                        });
                });
            } else if (this.index == 3) {
                window["_view"].zipFile().then((content) => {
                    let name = this.fileName;
                    if (!name.endsWith(".eddx")) {
                        name += ".eddx";
                    }
                    this.google.FileManager.uploadFile({
                        blob: content[0],
                        fileName: name,
                        parentId: this.drivePath.length > 0 ? this.drivePath[this.drivePath.length - 1].id : "",
                        thumb: "",
                    })
                        .then((res) => {
                            console.log(res);
                            this.getGoogleFile();
                            this.$edMessage.success(this.$t("saveSuccess"));
                            this.closeThis();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                });
            }
        }
        get showUpgradeVal() {
            return this.$store.state.publicStore.showUpgrade;
        }

        showCloudSpaceLimit() {
            if (!this.vip && this.showUpgradeVal != "cloudSpace") {
                this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
            } else if (this.vip && this.showUpgradeVal != "cloudSpaceVIP") {
                if (this.fuser) {
                    this.$bus.$emit("showCloudSpaceVipTips");
                } else {
                    this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                }
            }
        }

        saveToOss(pushHis) {
            window["_view"].zipFile().then((content) => {
                let canvas = window["_view"].saveTemplateThumbnailToCover();
                canvas.toBlob((blob) => {
                    let name = this.path.length > 0 ? this.path.join("/") + "/" + this.fileName : this.fileName;
                    if (!name.endsWith(".eddx")) {
                        name += ".eddx";
                    }
                    let obj = {
                        name: name,
                        size: content[0].size,
                        file: content[0],
                        img: blob,
                        versionDes: this.$t("versionDes"),
                        pushHis: pushHis,
                        folderId: this.folderId,
                        fileName: this.fileName,
                    };
                    if (this.isPrivate && pushHis) {
                        for (let item of this.filesList) {
                            if (item.name == this.fileName) {
                                Object.assign(obj, {
                                    file_key: item.key.match(/[^\/]*$/)[0],
                                });
                                break;
                            }
                        }
                    }
                    this.$store
                        .dispatch("saveFile", obj)
                        .then((res) => {
                            let isSaveSpecPage = this.$store.state.page.isSaveSpecPage;
                            if (!isSaveSpecPage) {
                                let ts: any = this;
                                if (this.isPrivate) {
                                    let obj = res.res.data.obj;

                                    window.history.pushState(
                                        {},
                                        "0",
                                        `${window.location.origin}${appConfig["sourcePath"]}app.html?` +
                                            ts.$zipFileName(`obj=${obj}&name=${this.fileName}`)
                                    );
                                    ts.$store.commit("setStatus", {
                                        type: "fileInfo",
                                        data: obj,
                                    });
                                    window["_view"]._doc._fileName = this.fileName;
                                    this.$store.commit("setStatus", {
                                        type: "fileNameSync",
                                        data: this.fileName,
                                    });
                                    document.title = document.title.replace(/.*-(.*)/, this.fileName + " -$1");
                                    this.$edMessage.success(this.$t("saveSuccess"));
                                    this.closeThis();
                                    return;
                                }
                                let prefix = this.path.join("/") + "/";
                                if (this.path.length == 0) {
                                    prefix = "";
                                }
                                // this.getFloder(prefix);

                                let result = ts.$store.state.ui.fileInfo;
                                if (result) {
                                    let obj = result.match(".*?/.*?/")[0];
                                    let newObj = obj + name;
                                    window.history.pushState(
                                        {},
                                        "0",
                                        `${window.location.origin}${appConfig["sourcePath"]}app.html?` + ts.$zipFileName(`obj=${newObj}`)
                                    );
                                    ts.$store.commit("setStatus", {
                                        type: "fileInfo",
                                        data: newObj,
                                    });
                                    window["_view"]._doc._fileName = this.fileName;
                                    this.$store.commit("setStatus", {
                                        type: "fileNameSync",
                                        data: this.fileName,
                                    });
                                    document.title = document.title.replace(/.*-(.*)/, this.fileName + " -$1");
                                } else {
                                    window.history.pushState(
                                        {},
                                        "0",
                                        `${window.location.origin}${appConfig["sourcePath"]}app.html?` +
                                            ts.$zipFileName(`obj=${this.userInfo.user_name}/Personal/${name}`)
                                    );
                                }
                            }
                            this.$edMessage.success(this.$t("saveSuccess"));
                            this.closeThis();
                        })
                        .catch((err) => {
                            if (err == "storageLimit") {
                                this.showCloudSpaceLimit();
                                this.$store.commit("setDialogState", {
                                    type: "showDialog",
                                    data: false,
                                });
                            }
                            if (err.data && err.data.obj && err.data.obj == "The obj format is invalid.") {
                                this.$edMessage.warning(this.$t("renameFail"));
                                (<any>this.$refs.nameInput).focus();
                            }
                            if (err.response.data && err.response.data.msg == "data invalid") {
                                this.$edMessage.warning(this.$t("renameFail"));
                                (<any>this.$refs.nameInput).focus();
                            }
                        });
                }, "image/png");
            });
        }

        // create folder
        checkFolderName(name, list) {
            let exit = 0,
                exitExpand = 0,
                exitFlag = true,
                numList = [];
            let p = new RegExp("(?=[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%])", "g"),
                ruleone = new RegExp("\^" + name.replace(p, "\\") + "\\\(\\\d+\\\)$"),
                ruletwo = new RegExp("\^" + name.replace(p, "\\") + "\\\((\\\d*)");

            for (let v of list) {
                if (exitFlag && v.name == name) {
                    exit = 1;
                    exitFlag = false;
                }
                if (ruleone.test(v.name)) {
                    let tempNum = ~~v.name.match(ruletwo)[1];
                    if (tempNum > 0) {
                        numList.push(tempNum);
                        exitExpand = 1;
                    }
                }
            }

            if (exit == 0) {
                return name;
            } else {
                if (exitExpand != 1) {
                    return `${name}(1)`;
                } else {
                    numList = numList.sort((a, b) => {
                        return a - b;
                    });
                    var k;
                    for (var i = 0, len = numList.length; i < len; i++) {
                        if (i + 1 != numList[i]) {
                            k = i + 1;
                            break;
                        } else {
                            k = numList[len - 1] + 1;
                        }
                    }
                    return `${name}(${k})`;
                }
            }
        }

        showCreateFolderBox() {
            // 打开创建文件夹弹窗
            if (this.lockCreate) return;
            let baseName = this.checkFolderName(this.$t("createFolder").toString(), this.folderList);
            this.folderName = baseName;
            // this.folderRenameShow = this.folderList.length - 1
            this.showCreateFolder = true;
            this.$nextTick(() => {
                let dom = <HTMLInputElement>document.getElementById("renameInput");
                dom.select();
                getSelection().collapseToEnd();
            });
        }
        okCreateFolder() {
            if (!this.folderName) {
                this.$edMessage.warning(this.$t("noEmpty"));
                return;
            }
            let hasFolder = false;
            this.folderList.forEach((f, i) => {
                if (f.name == this.folderName) {
                    hasFolder = true;
                }
            });
            if (hasFolder) {
                this.$edMessage.warning(this.$t("existFolder"));
                return;
            }
            this.lockCreate = true;
            let host = this.userInfo.user_name + "/Personal";
            let item = {
                name: this.folderName,
                prefix: this.path.length ? host + "/" + this.path.join("/") + "/" + this.folderName + "/" : host + "/" + this.folderName + "/",
            };
            this.folderList.push(item);

            let prefix = this.path.join("/");
            if (prefix) prefix = prefix + "/";
            this.$store
                .dispatch("createFolder", { prefix: prefix + this.folderName + "/" })
                .then((res) => {
                    this.$edMessage.success(this.$t("createSucc"));
                    this.lockCreate = false;
                })
                .catch((err) => {
                    this.lockCreate = false;
                    if (err.data.msg == "The prefix format is invalid.") {
                        this.folderList.pop();
                        this.$edMessage.warning(this.$t("invalidName"));
                    }
                    if (err.data && err.data.msg == "data invalid") {
                        this.folderList.pop();
                        this.$edMessage.warning(this.$t("invalidName"));
                    }
                });
        }
        cancelCreateFolder() {
            this.folderName = "";
        }
        //生命周期
        mounted() {
            window.onstorage = (e) => {
                if (e.key == "dropbox_access_token") {
                    this.dbx = new Dropbox({
                        accessToken: e.newValue,
                    });
                    this.dropboxPath = [];
                    this.getDropBoxFloder("");
                }
            };
            if (!this.userInfo) {
                let ts: any = this;
                ts.$bus.$emit("login");
            } else {
                this.getFloder("");
            }
        }

        created() {
            console.log(123);
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "另存为",
    "confirm": "确认",
    "cancel": "取消",
    "local": "本地",
    "cloud": "个人云",
    "google": "GoogleDrive",
    "dropbox": "Dropbox",
    "name": "名称",
    "time": "时间",
    "size": "大小",
    "fileName": "文件名",
    "tip": "提示",
    "noEmpty": "名字不能为空！",
    "cover": "覆盖或取消",
    "isCover": "目标文件夹已存在同名文件，是否要覆盖？",
    "saveSuccess": "保存成功",
    "createFolder": "新建文件夹",
    "inputFolderTip": "请输入文件夹名",
    "createSucc": "创建成功",
    "invalidName": "名字不能包含特殊字符",
    "existFolder": "文件夹已存在",
    "versionDes": "描述",
    "renameFail": "另存失败，名字不能包含特殊字符(& % $ 😊等)",
    "Personal": "个人云",
    "loading": "正在为您加载"
  },
  "en": {
    "title": "Save As",
    "confirm": "OK",
    "cancel": "Cancel",
    "local": "Local",
    "cloud": "Personal Cloud",
    "google": "GoogleDrive",
    "dropbox": "Dropbox",
    "name": "Name",
    "time": "Time",
    "size": "Size",
    "fileName": "File Name",
    "tip": "Reminder",
    "noEmpty": "Name cannot be empty.",
    "cover": "Replace or cancel?",
    "isCover": "A file with the same name already exists，do you want to replace it?",
    "saveSuccess": "Successfully Saved",
    "createFolder": "Create folder",
    "inputFolderTip": "Please type in folder name",
    "createSucc": "Create successfully ",
    "invalidName": "Invalid Name",
    "existFolder": "A folder with the same name has already existed.",
    "versionDes": "Description",
    "renameFail": "Save failed, check if the name contains special character, such as & % $ 😊, etc.",
    "Personal": "Personal",
    "loading": "Loading"
  },
  "jp": {
    "title": "名前を付けて保存",
    "confirm": "OK",
    "cancel": "キャンセル",
    "local": "ローカル",
    "cloud": "パーソナルクラウド",
    "google": "Googleドライブ",
    "dropbox": "Dropbox",
    "name": "名前",
    "time": "時間",
    "size": "サイズ",
    "fileName": "ファイル名",
    "tip": "ご注意",
    "noEmpty": "名前は空にできません！",
    "cover": "上書きまたはキャンセル",
    "isCover": "保存先には既に同じ名前のファイルが存在しています。上書きしますか？",
    "saveSuccess": "正常に保存されました",
    "createFolder": "フォルダの新規作成",
    "inputFolderTip": "フォルダ名を入力してください",
    "createSucc": "新規ファイルが作成しました",
    "invalidName": "無効な名前",
    "existFolder": "フォルダはすでに存在します",
    "versionDes": "説明",
    "renameFail": "保存に失敗しました。名前に特殊文字を含めることはできません(& % $ 😊など)",
    "Personal": "個人雲",
    "loading": "読み込み中"
  },
  "fr": {
    "title": "Enregistrer sous",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "local": "Local",
    "cloud": "Cloud personnel",
    "google": "GoogleDrive",
    "dropbox": "Dropbox",
    "name": "Nom",
    "time": "Temps",
    "size": "Taille",
    "fileName": "Nom de Fichier",
    "tip": "Rappel",
    "noEmpty": "Le nom ne peut pas être vide!",
    "cover": "Écraser ou Annuler",
    "isCover": "Un fichier du même nom existe déjà dans le dossier de destination. Voulez-vous le remplacer?",
    "saveSuccess": "Enregistré avec Succès",
    "createFolder": "Nouveau dossier",
    "inputFolderTip": "Veuillez saisir un nom de dossier",
    "createSucc": "Créé avec succès",
    "versionDes": "Description",
    "invalidName": "Nom illégal",
    "existFolder": "Le dossier existe déjà",
    "renameFail": "L'enregistrement a échoué, vérifiez si le nom contient un caractère spécial, tel que & % $ 😊, etc.",
    "pageSize5": "Exécutive",
    "Personal": "Cloud personnel",
    "loading": "Chargement en cours"
  },
  "de": {
    "title": "Speichern als",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "local": "Lokal",
    "cloud": "Persönliche Cloud",
    "google": "GoogleDrive",
    "dropbox": "Dropbox",
    "name": "Name",
    "time": "Datum",
    "size": "Größe",
    "fileName": "Dateiname",
    "tip": "Hinweis",
    "noEmpty": "Name darf nicht leer sein!",
    "cover": "Abdecken oder abbrechen",
    "isCover": "Eine gleichnamige Datei existiert bereits. Möchten Sie sie ersetzen?",
    "saveSuccess": "Erfolgreich gespreichert",
    "createFolder": "Neuer Ordner ",
    "inputFolderTip": "Bitte Ordnernamen einfügen",
    "createSucc": "Erfolgreich erstellt",
    "invalidName": "Ungültiger name",
    "existFolder": "Ein gleichnamiger Ordner ist bereits vorhanden",
    "versionDes": "Beschreibung",
    "renameFail": "Speichern fehlgeschlagen, prüfen Sie, ob der Name Sonderzeichen wie &% $ 😊 usw. enthält.",
    "Personal": "Persönliche Cloud",
    "loading": "Beladen"
  },
  "es": {
    "title": "Guardar como",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "local": "Local",
    "cloud": "Nube personal",
    "google": "GoogleDrive",
    "dropbox": "Dropbox",
    "name": "Nombre",
    "time": "Tiempo",
    "size": "Tamaño",
    "fileName": "Nombre del archivo",
    "tip": "Recordatorio",
    "noEmpty": "El nombre no puede estar vacío.",
    "cover": "¿Reemplazar o cancelar?",
    "isCover": "Un archivo con el mismo nombre ya exists，do quieres reemplazarlo?",
    "saveSuccess": "Guardado con éxito",
    "createFolder": "Crear carpeta",
    "inputFolderTip": "Por favor escriba el nombre de la carpeta",
    "createSucc": "Crear con éxito",
    "invalidName": "Nombre inválido",
    "existFolder": "Ya existe una carpeta con el mismo nombre.",
    "versionDes": "Descripción",
    "renameFail": "Guardar fallido, comprueba si el nombre contiene un carácter especial, como & % $ 😊, etc.",
    "Personal": "Nube personal",
    "loading": "Cargando"
  },
  "pt": {
    "title": "Gravar Como",
    "confirm": "OK",
    "cancel": "Cancelar",
    "local": "Local",
    "cloud": "Cloud Pessoal",
    "google": "GoogleDrive",
    "dropbox": "Dropbox",
    "name": "Nome",
    "time": "Hora",
    "size": "Tamanho",
    "fileName": "Nome do Ficheiro",
    "tip": "Alerta",
    "noEmpty": "Nome não pode estar vazio.",
    "cover": "Substituir ou cancelar?",
    "isCover": "Já existe um ficheiro com o mesmo nome, deseja substituir?",
    "saveSuccess": "Gravado com Sucesso",
    "createFolder": "Criar Pasta",
    "inputFolderTip": "Por favor, escrever no nome do ficheiro",
    "createSucc": "Criado com Sucesso",
    "invalidName": "Nome Inválido",
    "existFolder": "Já existe uma pasta com o mesmo nome.",
    "versionDes": "Descrição",
    "renameFail": "Falha ao gravar, verificar se o nome contém caracteres especiais, como & % $ 😊, etc.",
    "Personal": "Nuvem pessoal",
    "loading": "Carregando"
  },
  "it": {
    "title": "Salva Come",
    "confirm": "OK",
    "cancel": "Annulla",
    "local": "Locale",
    "cloud": "Cloud Personale",
    "google": "Google Drive",
    "dropbox": "Dropbox",
    "name": "Nome",
    "time": "Ora",
    "size": "Dimensione",
    "fileName": "Nome File",
    "tip": "Promemoria",
    "noEmpty": "Il campo del nome non può restare vuoto.",
    "cover": "Sostituire il file?",
    "isCover": "È già presente un file con questo nome. Desideri Sostituirlo?",
    "saveSuccess": "Salvataggio Avvenuto con Successo",
    "createFolder": "Crea Cartella",
    "inputFolderTip": "Immettere un nome per la cartella.",
    "createSucc": "Creazione eseguita con successo.",
    "invalidName": "Nome non Valido",
    "existFolder": "Esiste già una cartella con questo nome.",
    "versionDes": "Descrizione",
    "renameFail": "Salvataggio fallito. Assicurarsi che il nome del file non comprenda caratteri speciali, quali & % $ 😊, ecc.",
    "Personal": "Cloud personale",
    "loading": "Caricamento in corso"
  },
  "tw": {
    "title": "另存新檔",
    "confirm": "確認",
    "cancel": "取消",
    "local": "本地",
    "cloud": "個人雲端硬碟",
    "google": "GoogleDrive",
    "dropbox": "Dropbox",
    "name": "名稱",
    "time": "時間",
    "size": "大小",
    "fileName": "檔案名",
    "tip": "提示",
    "noEmpty": "名字不能為空！",
    "cover": "覆蓋或取消",
    "isCover": "目標資料夾已存在同名檔案，是否要覆蓋？",
    "saveSuccess": "儲存成功",
    "createFolder": "新建資料夾",
    "inputFolderTip": "請輸入資料夾名",
    "createSucc": "建立成功",
    "invalidName": "名字不能包含特殊字符",
    "existFolder": "資料夾已存在",
    "versionDes": "描述",
    "renameFail": "另存新檔失敗，名字不能包含特殊字符(& % $ 😊等)",
    "Personal": "個人云",
    "loading": "正在為您加載"
  },
  "kr": {
    "title": "다른 이름으로 저장하기",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "local": "로컬",
    "cloud": "개인운",
    "google": "GoogleDrive",
    "dropbox": "Dropbox",
    "name": "이름",
    "time": "시간 ",
    "size": "크기 ",
    "fileName": "파일 이름",
    "tip": "힌트",
    "noEmpty": "名字不能为空！",
    "cover": "覆盖或取消",
    "isCover": "目标文件夹已存在同名文件，是否要覆盖？",
    "saveSuccess": "保存成功",
    "createFolder": "新建文件夹",
    "inputFolderTip": "请输入文件夹名",
    "createSucc": "创建成功",
    "invalidName": "名字不能包含特殊字符",
    "existFolder": "文件夹已存在",
    "versionDes": "描述",
    "renameFail": "另存失败，名字不能包含特殊字符(& % $ 😊等)",
    "Personal": "个人云",
    "loading": "로드"
  }
}
</i18n>
